import {CdkNavigation, CdkNavigationItem} from '@cdk/types';
import {modulesConfig} from '../../modules/modules-config';

export let navigationConverter = {
    'arquivistico': 'arquivístico'
};

modulesConfig.forEach((module) => {
    if (module.navigationConverter?.hasOwnProperty('mainMenu')) {
        navigationConverter = {
            ...navigationConverter,
            ...module.navigationConverter.mainMenu
        };
    }
});

export const navigation: CdkNavigation[] = [
    {
        id: 'applications',
        title: 'Aplicações',
        translate: 'NAV.APPLICATIONS',
        type: 'group',
        children: [
            {
                id: 'painel',
                title: 'Painel',
                translate: 'NAV.PAINEL.TITLE',
                type: 'item',
                icon: 'dashboard',
                url: '/apps/painel',
                role: 'ROLE_USER'
            },
            {
                id: 'tarefas',
                title: 'Tarefas',
                translate: 'NAV.TAREFA.TITLE',
                type: 'collapsable',
                startExpanded: true, // ALTERADO PELA PGE-RS: adicionado.
                icon: 'check_box',
                allowGroupOfHiddenChildren: true,
                children: [
                    {
                        id: 'tarefas_pendentes_administrativo',
                        title: 'Administrativas',
                        translate: 'NAV.TAREFA.ADMINISTRATIVAS.TITLE',
                        type: 'item',
                        icon: 'person',
                        hideable: true,
                        url: '/apps/tarefas/administrativo/minhas-tarefas/entrada',
                        badge: {
                            title: '0',
                            bg : '#F44336',
                            fg: '#FFFFFF'
                        },
                        badgeCompartilhada: {
                            id: 'tarefas_compartilhadas_administrativo',
                            parent: false,
                            badge: {
                                title: '0',
                                bg: '#fc6054',
                                fg: '#FFFFFF'
                            }
                        },
                        canHide: (item: CdkNavigationItem): boolean => {
                            let countBadges = 0;
                            countBadges = parseInt(item.badge?.title, 10);
                            if (item.badgeCompartilhada) {
                                countBadges += parseInt(item.badgeCompartilhada.badge?.title, 10);
                            }
                            return countBadges === 0;
                        },
                        role: 'ROLE_COLABORADOR'
                    },
                    {
                        id: 'tarefas_pendentes_arquivístico',
                        title: 'Arquivísticas',
                        type: 'item',
                        icon: 'archive',
                        hideable: true,
                        url: '/apps/tarefas/arquivistico/minhas-tarefas/entrada',
                        badge: {
                            title: '0',
                            bg : '#F44336',
                            fg: '#FFFFFF'
                        },
                        badgeCompartilhada: {
                            id: 'tarefas_compartilhadas_arquivístico',
                            parent: false,
                            badge: {
                                title: '0',
                                bg: '#fc6054',
                                fg: '#FFFFFF'
                            }
                        },
                        canHide: (item: CdkNavigationItem): boolean => {
                            let countBadges = 0;
                            countBadges = parseInt(item.badge?.title, 10);
                            if (item.badgeCompartilhada) {
                                countBadges += parseInt(item.badgeCompartilhada.badge?.title, 10);
                            }
                            return countBadges === 0;
                        },
                        role: 'ROLE_COLABORADOR'
                    }
                ],
                role: 'ROLE_COLABORADOR'
            },
            // ALTERADO PGE: https://pgepaegitlab01.pge.reders/supp/supp-administrativo-frontend/-/issues/173
            {
                id: 'carga-documentos',
                title: 'Carga de Documentos',
                translate: 'NAV.CARGA.TITLE',
                type: 'item',
                icon: 'file_upload',
                url: '/apps/carga',
                role: 'ROLE_COLABORADOR'
            },
            {
                id: 'oficios',
                title: 'Ofícios',
                translate: 'NAV.OFICIO.TITLE',
                type: 'item',
                icon: 'library_books', // ALTERADO PELA PGE-RS
                url: '/apps/oficios/entrada',
                role: ['ROLE_PESSOA_VINCULADA', 'ROLE_DISCIPLINAR_INTERESSADO']
            },
            {
                id: 'protocolo-externo',
                title: 'Protocolo',
                translate: 'NAV.PROTOCOLO_EXTERNO.TITLE',
                type: 'item',
                icon: 'check_box',
                url: '/apps/protocolo-externo/meus-processos/entrada',
                role: 'PGERS_MENU_DESABILITADO_ROLE_USUARIO_EXTERNO_VALIDADO'
            },
            {
                id: 'protocolo',
                title: 'Protocolo',
                translate: 'NAV.PROTOCOLO.TITLE',
                type: 'collapsable',
                icon: 'create_new_folder', // ALTERADO PELA PGE-RS: ícone
                allowGroupOfHiddenChildren: true,
                children: [
                    {
                        id: 'administrativo',
                        title: 'Administrativo',
                        type: 'item',
                        icon: 'person', // ALTERADO PELA PGE-RS: ícone
                        url: '/apps/processo/criar/editar/dados-basicos-steps/administrativo'
                    },
                    {
                        id: 'caixa-email',
                        title: 'E-mail',
                        translate: 'NAV.CAIXA_EMAIL.TITLE',
                        type: 'item',
                        icon: 'mail',
                        role: 'ROLE_PROTOCOLO_EMAIL',
                        url: '/apps/caixa-email/default/default'
                    }
                ],
                role: 'ROLE_COLABORADOR'
            },
            {
                id: 'pesquisa',
                title: 'Pesquisa',
                translate: 'NAV.PESQUISA.TITLE',
                type: 'item',
                icon: 'search',
                url: '/apps/pesquisa/processos',
                role: 'ROLE_USER'
            },
            // ALTERADO PELA PGE-RS: BD-0.
            {
                id: 'relatorios',
                title: 'Relatórios',
                translate: 'NAV.RELATORIOS.TITLE',
                type: 'collapsable',
                icon: 'table_chart',
                role: 'ROLE_COLABORADOR',
                children: [
                    {
                        id: 'relatorio',
                        title: 'SUPP',
                        translate: 'NAV.RELATORIO.TITLE',
                        type: 'item',
                        icon: 'assessment',
                        url: '/apps/relatorios/administrativo/meus-relatorios/entrada',
                        role: 'ROLE_COLABORADOR'
                    },
                    {
                        id: 'bd0',
                        title: 'SUPP BD-0',
                        translate: 'NAV.BD0.TITLE',
                        type: 'item',
                        icon: 'launch',
                        url: 'http://parla.pge.reders/app/supp',
                        externalUrl: true,
                        openInNewTab: true,
                        role: 'ROLE_COLABORADOR'
                    },
                    {
                        id: 'nup_nucleo',
                        title: 'NUPs do Setor Principal/Núcleo',
                        translate: 'NAV.NUPS_POR_NUCLEO.TITLE',
                        type: 'item',
                        icon: 'launch',
                        url: 'http://parla.pge.reders/app/supp_nups_por_nucleo',
                        externalUrl: true,
                        openInNewTab: true,
                        role: 'ROLE_COLABORADOR',
                    }
                ]
            }
        ]
    },
    {
        id: 'modulos',
        title: 'Módulos',
        translate: 'NAV.MODULES',
        type: 'collapsable',
        startExpanded: true, // ALTERADO PELA PGE-RS: adicionado.
        icon: 'grid_on',
        role: 'ROLE_COLABORADOR',
        children: [
            {
                id: 'admin',
                title: 'Administrador',
                translate: 'NAV.ADMIN.TITLE',
                type: 'item',
                icon: 'build',
                url: '/apps/admin',
                role: 'ROLE_ADMIN' // ALTERADO PELA PGE-RS: removida esta ROLE, estava mostrando o menu Administrador para quem não é , 'ROLE_*_ADMIN']
            },
            {
                id: 'arquivista',
                title: 'Arquivista',
                translate: 'NAV.ARQUIVISTA.TITLE',
                type: 'item',
                icon: 'archive',
                url: '/apps/arquivista',
                role: 'ROLE_ARQUIVISTA'
            },
            {
                id: 'coordenador',
                title: 'Coordenador',
                translate: 'NAV.COORDENADOR.TITLE',
                type: 'item',
                icon: 'tune',
                url: '/apps/coordenador/default',
                role: 'ROLE_COORDENADOR',
                isCoordenador: true
            }
        ]
    },
    {
        id: 'cadastro_advogados',
        title: 'Advogados',
        translate: 'NAV.ADVOGADOS.TITLE',
        type: 'item',
        icon: 'person',
        url: '/apps/advogados/editar/criar',
        role: 'ROLE_CAD_ADVOGADO'
    }
];


